module.exports = __webpack_public_path__ + "static/media/safe-closet.af47b50e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/hero/safe-closet.jpg
// module id = 1244
// module chunks = 0